import { render, staticRenderFns } from "./RichMenuActionForm.vue?vue&type=template&id=28e5a9b3&scoped=true&"
import script from "./RichMenuActionForm.vue?vue&type=script&lang=js&"
export * from "./RichMenuActionForm.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuActionForm.vue?vue&type=style&index=0&id=28e5a9b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5a9b3",
  null
  
)

export default component.exports